var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalAmount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 36.5,
    r: 32.5,
    fill: "#27B783"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.7829 30.3381L47.0585 32.8097H33.2517L33.9761 30.3381H47.7829ZM41.3057 47L33.5074 37.4545L33.4648 35.6648H37.3426C38.3511 35.6648 39.2105 35.5227 39.9207 35.2386C40.6309 34.9474 41.1743 34.5142 41.5507 33.9389C41.9271 33.3565 42.1153 32.625 42.1153 31.7443C42.1153 30.4446 41.7247 29.4254 40.9434 28.6868C40.1622 27.9411 38.9619 27.5682 37.3426 27.5682H33.2517L33.9761 25.1818H37.3426C39.0756 25.1818 40.496 25.4695 41.604 26.0447C42.719 26.6129 43.5429 27.3942 44.0756 28.3885C44.6153 29.3757 44.8852 30.4943 44.8852 31.7443C44.8852 32.8736 44.6366 33.9141 44.1395 34.8658C43.6494 35.8104 42.8611 36.5703 41.7744 37.1456C40.6949 37.7209 39.2673 38.0085 37.4917 38.0085H37.4278L44.6295 46.8295V47H41.3057ZM47.7829 25.1818L47.0585 27.6534L36.192 27.5682L36.9165 25.1818H47.7829Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: 0,
    y: 0,
    width: 81,
    height: 81,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalAmount);
export default __webpack_public_path__ + "static/media/totalAmount.b56679bf860fb1b84e46c9ad5204ac0b.svg";
export { ForwardRef as ReactComponent };